import React, { useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';
import MenuItem from '../../../Shared/Table/widgets/MenuItem';
import { ReactComponent as UsersIcon } from '../../../../assets/icons/users.svg';
import { ReactComponent as EditIcon } from '../../../../assets/icons/edit.svg';
import { checkPermission } from '../../../../helpers/checkPermissions';
import permissions from '../../../../config/permissions';
import CloudUpload from '@material-ui/icons/CloudUpload';
import { ReactComponent as DownloadIcon } from '../../../../assets/icons/file_download_black.svg';
import { ReactComponent as RemoveIcon } from '../../../../assets/icons/remove.svg';
import { routes } from '../../../../config/routes';
import { AppRouteContext } from '../../../../contexts';

const TableActions = ({
                        row,
                        setAnchorEl,
                        setDownloadAccount,
                        setOpenRemoveDialog,
                        setRemovingAccount,
                      }) => {
  const {
    en: {
      titles,
    },
  } = useSelector((state) => state.i18n);
  const { setAppRoute } = useContext(AppRouteContext);

  const {
    metadata: { currentAccountPermissions },
    isDistributionSponsor,
  } = useSelector((state) => state.user);

  const handleItemClick = (path, title, uuid, businessName) => {
    setAppRoute({
      path: routes[path].path,
      params: { accountUuid: uuid, title: businessName },
      title: title,
    });
  };

  const handleDownloadPracticeOptimizationReportClick = (e, {
    uuid,
    businessName,
  }) => setDownloadAccount({ uuid: uuid, businessName: businessName });

  const handleRemoveItemClick = (e, account) => {
    setOpenRemoveDialog(true);
    setRemovingAccount(account);
  };

  const hasImportPermission = useMemo(
    () => checkPermission(
      currentAccountPermissions,
      permissions.ADMIN_PATIENT_IMPORT,
    ),
    [currentAccountPermissions],
  );

  const actions = [
    {
      key: '1',
      icon: <UsersIcon />,
      onActionClick: (e, { uuid, businessName }) => {
        handleItemClick('accountUsers', isDistributionSponsor ? `${titles.users}: ${businessName}` : titles.users, uuid);
      },
      children: titles.editUsers,
    },
    {
      key: '2',
      icon: <EditIcon />,
      onActionClick: (e, { uuid }) => {
        handleItemClick('accountEdit', titles.editAccount, uuid);
      },
      children: titles.editAccount,
    },
    ...hasImportPermission ? [{
      key: '3',
      icon: <CloudUpload style={{ fontSize: 16 }} />,
      onActionClick: (e, { uuid, businessName }) => {
        handleItemClick('patientUpload', titles.patientUpload, uuid, businessName);
      },
      children: titles.patientUpload,
      addDivider: true,
    }, {
      key: '4',
      icon: <CloudUpload style={{ fontSize: 16 }} />,
      onActionClick: (e, { uuid, businessName }) => {
        handleItemClick('insuranceUpload', titles.insuranceUpload, uuid, businessName);
      },
      children: titles.insuranceUpload,
    }, {
      key: '5',
      icon: <CloudUpload style={{ fontSize: 16 }} />,
      onActionClick: (e, { uuid, businessName }) => {
        handleItemClick('providersUpload', titles.providersUpload, uuid, businessName);
      },
      children: titles.providersUpload,
    }, {
      key: '6',
      icon: <CloudUpload style={{ fontSize: 16 }} />,
      onActionClick: (e, { uuid, businessName }) => {
        handleItemClick('claimsUpload', titles.claimsUpload, uuid, businessName);
      },
      children: titles.claimsUpload,
    }] : [],
    ...hasImportPermission ? [{
      key: '7',
      icon: <DownloadIcon />,
      onActionClick: handleDownloadPracticeOptimizationReportClick,
      children: titles.downloadPracticeOptimizationReport,
      addDivider: true,
    }] : [],
    {
      key: '8',
      icon: <RemoveIcon />,
      onActionClick: handleRemoveItemClick,
      children: titles.removeAccount,
      isRemove: true,
      addDivider: true,
    },
  ];

  const children = useMemo(
    () => actions.map((props) => {
      const { children, onActionClick, icon, addDivider, isRemove } = props;
      return <MenuItem
        title={children}
        icon={icon}
        setAnchorEl={setAnchorEl}
        onClick={(e) => onActionClick(e, row.original)}
        hasTopDriver={addDivider}
        isErrorStyle={isRemove}
      />;
    }),
    [row],
  );

  return <>
    {children}
  </>;
};

export default TableActions;
